<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="(addNewDataSidebar = false), (selected = [])"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
    />

    <vs-table
      noDataText="Nenhuma Divisão Encontrada"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :max-items="itemsPerPage"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="inativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="reativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>

          <!------------ START ADD NOVO Divisão ------------>
          <div
            class="h-full rounded-lg flex items-center justify-center mb-4 gap-4"
          >
            <button
              class="p-4 rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary bg-white"
              @click="openSideBar()"
              v-if="$can($actionsDefault.Escrita, subjectPermission)"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary"
                >Adicionar nova Assessoria</span
              >
            </button>
            <vs-button
              v-if="$can($actionsDefault.Exportar, subjectPermission)"
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              class="p-custom"
              @click="exportXls"
            >
              Exportar
            </vs-button>
          </div>
        </div>
        <!------------ END ADD NOVO Divisão ------------>
        <div class="flex">
          <!------------ START ITENS POR PÁGINA ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  count - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : count
                }}
                de {{ count }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END ITENS POR PÁGINA ------------>
          <vs-input
            icon="search"
            placeholder="Nome da Assessoria"
            v-model="corretorasSearched"
          />
        </div>
      </div>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="Nome">Nome</vs-th>
        <vs-th sort-key="Usuario">CNPJ</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.divisionName }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.cnpj }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td class="w-48">
              <div class="buttons-options-grid">
                <vs-button
                  radius
                  v-tooltip="'Detalhes'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="button-option"
                  @click="opemModal(tr.id)"
                />
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="button-option"
                  @click="openSideBar(tr.id)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                />
                <vs-button
                  radius
                  v-tooltip="'Histórico de Alterações'"
                  color="#88abc2"
                  icon-pack="feather"
                  icon="icon-archive"
                  class="button-option"
                  @click="abrirModalHistoricoUsuarios(tr)"
                />
                <vs-button
                  v-if="occurrencePermission"
                  radius
                  v-tooltip="'Ocorrências'"
                  color="warning"
                  icon-pack="feather"
                  icon="icon-clipboard"
                  class="button-option"
                  @click="openOccurrencesModal(tr)"
                />
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!------------ END TABELA ------------>
    <div class="mt-6">
      <vs-pagination
        :total="parseInt(count / itemsPerPage) + 1"
        v-model="currentPage"
      ></vs-pagination>
    </div>

    <!------------ START INFORMAÇÕES DO Divisão ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados da ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <!------------ END INFORMAÇÕES DO Divisão ------------>
    <ModalHistoricoAlteracoes
      :popupActive="popupAlteracoesActive"
      :tipo="tipoHistorico"
      :nome="nomeHistorico"
      :dadosConsulta="dadosConsultaHistorico"
      @close="fecharModalHistorico"
    ></ModalHistoricoAlteracoes>

    <ModalShowAndCreateOccurrences
      v-if="occurrencePermission"
      :entityId="activeOccurrencesConsultancy"
      :popupActive="popupOccurrences"
      :saveOccurrenceApi="occurrenceApi.saveConsultancyOccurrence"
      :getOccurrencesApi="occurrenceApi.getConsultancyOccurrences"
      @close="popupOccurrences = false"
    />
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import ModalInfo from '../../components/ModalInfo';
import ModalHistoricoAlteracoes from '../modais/ModalHistoricoAlteracoes.vue';
import AddNewDataSidebar from './../Includes/SideBar';

import service from '../../services';
import consultancyApi from '../../services/consultancy.api.js';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ModalShowAndCreateOccurrences from '../modais/ModalShowAndCreateOccurrences.vue';
import occurrenceApi from '../../services/occurrence.api';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../constants/permissions';

export default {
  components: {
    AddNewDataSidebar,
    ModalInfo,
    ModalHistoricoAlteracoes,
    ModalShowAndCreateOccurrences,
  },
  props: ['subjectPermission'],
  data() {
    return {
      occurrenceApi,
      dadosSideBar: {},
      controllerGeral: 'divisao',
      formSideBar: 'Corretora',
      entidade: 'Assessoria',
      titleSideBar: 'Adicionar Assessoria',
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      currentPage: 1,
      count: 0,
      itemsPerPage: 10,
      addNewDataSidebar: false,
      corretorasSearched: null,
      debounce: functions.debounce(this.buscaDados, 1000),
      dadosConsultaHistorico: [],
      tipoHistorico: 'Assessoria',
      nomeHistorico: '',
      popupAlteracoesActive: false,
      popupOccurrences: false,
      activeOccurrencesConsultancy: null,
      cachedConsultanciesDetails: {},
    };
  },
  computed: {
    occurrencePermission() {
      return this.$can(
        PERMISSIONS_ACTIONS.OCCURRENCE,
        PERMISSIONS_NAMES.CONSULTANCY,
      );
    },
  },
  watch: {
    currentPage() {
      this.buscaDados();
    },
    itemsPerPage() {
      this.buscaDados();
    },
    corretorasSearched: {
      handler: function () {
        this.debounce();
      },
    },
  },
  methods: {
    async exportXls() {
      try {
        const response = await consultancyApi.exportConsultanciesXls({
          name: this.corretorasSearched ? this.corretorasSearched : undefined,
        });
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Assessorias - ${now}.xlsx`;

        await functions.downloadFromBuffer(window, response, fileName);
      } catch (e) {
        notify.notifyFail(this.$vs, e);
      }
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.id);
        });
        service
          .post(this.controllerGeral, 'Inativar', { ids: ids })
          .then(() => {
            notify.notifySuccess(
              this.$vs,
              'Assessoria(s) e todos os usuários vinculados à ela foram inativados com sucesso',
            );
            this.buscaDados();
          })
          .catch((e) => notify.notifyFail(this.$vs, e))
          .finally(() => this.$vs.loading.close());
      } else {
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.id);
        });
        service
          .post(this.controllerGeral, 'Reativar', { ids: ids })
          .then(() => {
            notify.notifySuccess(this.$vs, 'Registro reativado(s) com sucesso');
            this.buscaDados();
          })
          .catch((e) => notify.notifyFail(this.$vs, e))
          .finally(() => this.$vs.loading.close());
      } else {
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
      }
    },
    async buscaDados() {
      this.dadosSideBar = null;
      this.selected = [];
      this.$vs.loading();
      try {
        const response = await consultancyApi.getConsultancies({
          name: this.corretorasSearched || undefined,
          page: this.currentPage,
          itemsPerPage: this.itemsPerPage,
        });
        this.itens = response.rows;
        this.count = response.count;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getConsultancyDetails(consultancyId) {
      let consultancyDetails = this.cachedConsultanciesDetails[consultancyId];
      if (!consultancyDetails) {
        consultancyDetails = await this.fetchConsultancyDetails(consultancyId);
        this.$set(
          this.cachedConsultanciesDetails,
          consultancyId,
          consultancyDetails,
        );
      }
      return consultancyDetails;
    },
    async fetchConsultancyDetails(consultancyId) {
      this.$vs.loading();
      try {
        const res = await service.getAll(
          this.controllerGeral,
          {},
          consultancyId,
        );
        return res.data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async openSideBar(consultancyId) {
      const consultancyDetails = consultancyId
        ? await this.getConsultancyDetails(consultancyId)
        : {};

      consultancyDetails.idDivisao == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados da ${this.entidade}`);

      this.dadosSideBar = { ...consultancyDetails };
      this.addNewDataSidebar = true;
    },
    async opemModal(consultancyId) {
      this.modalSelecionado = [];
      this.popupActive = true;
      const consultancyDetails = await this.getConsultancyDetails(
        consultancyId,
      );
      Object.keys(consultancyDetails).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: consultancyDetails[element],
          });
      });
    },
    openOccurrencesModal(item) {
      this.activeOccurrencesConsultancy = item.id;
      this.popupOccurrences = true;
    },
    concluido(consultancyId) {
      this.dadosSideBar = null;
      this.selected = [];
      this.addNewDataSidebar = false;

      this.$forceUpdate();
      this.buscaDados();
      this.$delete(this.cachedConsultanciesDetails, consultancyId);
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    async getDados() {
      try {
        const promises = [this.buscaDados()];

        await Promise.all(promises);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    abrirModalHistoricoUsuarios(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'divisoes',
          id: item.id,
        },
      ];
      this.nomeHistorico = item.divisionName;
      this.popupAlteracoesActive = true;
    },
    fecharModalHistorico() {
      this.popupAlteracoesActive = false;
    },
  },
  async created() {
    this.getDados();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

.p-custom {
  padding: 0.95rem !important;
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="scss" scoped>
.buttons-options-grid {
  display: grid;
  grid-template-columns: repeat(2, 38px);
  gap: 6px;
}

.button-option {
  width: 38px;
  height: 38px;
}
</style>

<!------------ END STYLE ------------>
